import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 40px 56px;
  height: calc(100vh - 80px);
  overflow: auto;
  overflow: overlay;
`;

export const TitleWrapper = styled.div`
  padding-bottom: 40px;
`;

export const Title = styled.h1`
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 0px;
  line-height: 1em;
  color: var(--colorBlueGray1200);
  margin-bottom: 16px;
`;

export const Description = styled.p`
  color: var(--colorBlueGray800);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;
